import { render, staticRenderFns } from "./Grupos.vue?vue&type=template&id=f6201b84&scoped=true"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"
import style0 from "./Grupos.vue?vue&type=style&index=0&id=f6201b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6201b84",
  null
  
)

export default component.exports